export { default } from './CapabilitiesLayout';
